import { createSlice } from '@reduxjs/toolkit';

const messageSlice = createSlice({
  name: 'message',
  initialState: {
    text: null,
    status: null,
    isVisible: false
  },
  reducers: {
    setMessage(state, action) {
      state.text = action.payload.text
      state.status = action.payload.status
      state.isVisible = true
    },
    restMessage(state) {
      state.text = null
      state.status = null
      state.isVisible = false
    },
  },
})

export default messageSlice
